import { useEffect } from "react";
import { usePatchPropertyLandMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyLandMutation";
import type { ClientPropertyLandDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getLandFormSchema } from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";
import { mapPropertyToLandForm } from "web_myplann/Portfolio/Forms/LandForm/mapPropertyToLandForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditLandFormArgs = {
	propertyId: number;
	property: ClientPropertyLandDetailResponseDTO;
	detailRoute: string;
};

export const useEditLandForm = ({
	propertyId,
	property,
	detailRoute,
}: UseEditLandFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPropertyLandMutation(propertyId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getLandFormSchema(t),
		defaultValues: mapPropertyToLandForm(property),
		mutate,
		successToast: t(Resources.Portfolio.EditLand.savedToast, {
			type: t(Resources.Portfolio.AddLand.title),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
